export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/stairs-4724adbd2af0d9c2dd1eb4459de76032.png";